'use strict';

const ppc = require( '../../../../../_plugins/lib/ppc.js' );
const Helpers = require( '../../../../../_plugins/lib/helpers.js' );
const Config = require( '../../../../../config/index.js' );

const EngineHelper = {
  getHiddenInput( name, options, expiry, domain ) {
    if ( !name ) return false;
    let value = options && ppc.searchQueryStringAndSet( options );
    if ( !value ) value = Helpers.getCookie( name );
    if ( value ) Helpers.setCookie( name, value, expiry, domain );
    return value;
  },
  engineCookies (name, value) {
    if (this.props && this.props.engineType) name = this.props.engineType + name // Incase you want to keep engines separate
    name = 'Engines_' + name
    if (typeof value === 'undefined') return Helpers.getCookie(name)
    if (!value) return Helpers.setCookie(name, value, (d => new Date(d.setDate(d.getDate() - 1)))(new Date()))
    Helpers.setCookie(name, value)
  },
  setupCalendars (params) {
    const i = setInterval(() => {
      if (!window.SetupCalendars) return
      clearInterval(i)
      return new window.SetupCalendars(params)
    }, 50)
  },
  checkUpdated (next, current) {
    if (typeof next === 'object') {
      return JSON.stringify(next) !== JSON.stringify(current)
    }
    return next !== current
  },
  getHiddenInputs( ) {
    let expiry = new Date();
    expiry.setTime( expiry.getTime( ) + Config.settings.cookieExpiryDays * 24 * 60 * 60 * 1000 );
    const hiddenInputs = {};
    hiddenInputs.LaunchID = this.getHiddenInput( 'LaunchID', [ 'launch_id', 'LaunchID' ], expiry, Config.settings.cookieDomain );
    hiddenInputs.custref = this.getHiddenInput( 'custref', [ 'cust_ref', 'custref', 'customer_ref' ], expiry, Config.settings.cookieDomain );
    hiddenInputs.Email = this.getHiddenInput( 'Email', [ 'email', 'email_address' ], expiry, Config.settings.cookieDomain );
    hiddenInputs.CampaignID = this.getHiddenInput( 'CampaignID', [ 'CampaignID', 'Campaign_ID' ], expiry, Config.settings.cookieDomain );
    this.setState({
      hiddenInputs
    });
  }
};

module.exports = EngineHelper;



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/engines/engineHelper.js